// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YACwW","col":"styles_col__quM5b"};